export default __webpack_public_path__ + "cc93ef0b9c4ff81749906064687a302b.jpeg";